var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoPlayerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.73,
    height: 13.175,
    viewBox: "0 0 16.73 13.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M19.73,11.387v10.4a1.441,1.441,0,0,1-1.487,1.387H4.487A1.441,1.441,0,0,1,3,21.788V12.427H4.487v9.361H18.243v-10.4H3A1.441,1.441,0,0,1,4.487,10H18.243A1.441,1.441,0,0,1,19.73,11.387ZM9.842,19.272a.652.652,0,0,0,.309-.077l3.916-2.108a.558.558,0,0,0,0-1l-3.916-2.109a.659.659,0,0,0-.618,0,.573.573,0,0,0-.309.5V18.7a.572.572,0,0,0,.309.5A.654.654,0,0,0,9.842,19.272Z",
    transform: "translate(-3 -10)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayerIcon);
export default __webpack_public_path__ + "static/media/video-player-icon.7b1eff67.svg";
export { ForwardRef as ReactComponent };